import { CalendarCheck, Repeat, Video } from 'lucide-react';
import { RealScreen } from '@/components/marketing/roleKit';

/**
 * Students Real Screen 2: sessions. Static and clock-free (no Date), so the prerendered HTML is stable.
 * Folds the retired Zoom/Recurring sections into callouts: the meeting link and weekly series.
 */
const TIMES: readonly { day: string; slot: string; picked?: boolean }[] = [
  { day: 'Mon', slot: '4:00 PM' },
  { day: 'Wed', slot: '5:30 PM', picked: true },
  { day: 'Fri', slot: '3:00 PM' },
];

export function FeatureDetailSection() {
  return (
    <RealScreen
      id="section-sessions"
      audience="students"
      layout="rail-left"
      heading="Agree a time, then just show up"
      lede="Your tutor proposes a time. You accept, or suggest another. Either side can counter until you both agree."
      callouts={[
        { icon: CalendarCheck, title: 'Counter-propose any time', body: 'Suggest a different slot and the proposal updates for both of you.' },
        { icon: Video, title: 'Your meeting link is made for you', body: 'When you both agree, the session gets a Google Meet link and a calendar entry.' },
        { icon: Repeat, title: 'Weekly sessions, once you have met', body: 'After your first completed session you can ask for a recurring series. Your tutor approves it.' },
      ]}
      caption="Example session proposal."
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border bg-background p-4">
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold">Time proposal</p>
            <span className="rounded-full border border-amber-400 px-2 py-0.5 text-xs text-amber-700 dark:text-amber-400">Pending</span>
          </div>
          <p className="mt-1 text-xs text-muted-foreground">Proposed by your tutor · 60 minutes</p>
          <ul className="mt-3 grid grid-cols-3 gap-2">
            {TIMES.map((t) => (
              <li
                key={t.day}
                className={`rounded-lg border px-2 py-2 text-center ${t.picked ? 'border-primary bg-primary/10' : 'bg-muted/40'}`}
              >
                <p className="text-xs text-muted-foreground">{t.day}</p>
                <p className="text-sm font-semibold">{t.slot}</p>
              </li>
            ))}
          </ul>
          <div className="mt-4 flex gap-2" aria-hidden>
            <span className="inline-flex h-8 items-center rounded-md bg-primary px-3 text-xs font-medium text-primary-foreground">Accept</span>
            <span className="inline-flex h-8 items-center rounded-md border px-3 text-xs font-medium">Counter-propose</span>
          </div>
        </div>
        <div className="rounded-xl border border-emerald-300/60 bg-emerald-50/70 p-4 dark:border-emerald-800/50 dark:bg-emerald-950/20">
          <p className="text-sm font-semibold text-emerald-800 dark:text-emerald-300">Session confirmed</p>
          <p className="mt-1 text-sm">SAT Math · Wed 5:30 PM</p>
          <p className="text-xs text-muted-foreground">60 minutes, online</p>
          <div className="mt-4 flex items-center gap-2 rounded-lg border bg-background px-3 py-2 text-sm" aria-hidden>
            <Video className="h-4 w-4 text-emerald-700 dark:text-emerald-400" />
            Join with Google Meet
          </div>
        </div>
      </div>
    </RealScreen>
  );
}
